module.exports = __webpack_public_path__ + "static/media/mental-health-news.c005d505.jpg";